// extracted by mini-css-extract-plugin
export default {"starterScreen":"hk","starterImage":"ik","already":"jk","btnContainer":"kk","starterImageMobile":"lk","starterTextContainWrapper":"mk","controlX":"nk","attrWrapper":"ok","logoWrapper":"pk","starterTextContain":"qk","starterHeader":"rk","starterBtn":"sk","starterSecondaryBtn":"tk","starterBanner":"uk","logoWrapperMob":"vk","mobileBtnContainer":"wk"};
    if(module.hot) {
      // 1713912562384
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  